import { currentFootballCoreLocation, isSafeRelativeNavigationTarget } from '~/lib/navigation/football-core'

interface AuthRedirectLocation {
  pathname?: string
  search?: unknown
}

function returnTargetFromSearch(search: unknown): string | undefined {
  if (!search)
    return undefined

  if (typeof search === 'string') {
    const values = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search).getAll('returnTo')
    return values.length === 1 ? values[0] : undefined
  }

  if (typeof search === 'object' && 'returnTo' in search) {
    const returnTo = search.returnTo
    return typeof returnTo === 'string' ? returnTo : undefined
  }

  return undefined
}

function isAuthLoop(target: string): boolean {
  const pathname = new URL(target, 'https://ballpeek.invalid').pathname
  const unprefixed = pathname.startsWith('/zh-CN/') ? pathname.slice('/zh-CN'.length) : pathname
  return unprefixed === '/auth' || unprefixed.startsWith('/auth/')
}

export function authRecoveryHref(location: {
  pathname: string
  searchStr?: string
  hash?: string
}): string {
  const authPath = location.pathname === '/zh-CN' || location.pathname.startsWith('/zh-CN/')
    ? '/zh-CN/auth/sign-in'
    : '/auth/sign-in'
  return `${authPath}?returnTo=${encodeURIComponent(currentFootballCoreLocation(location))}`
}

export function resolveAuthRedirectTo(location: AuthRedirectLocation, fallback?: string): string {
  const localeFallback = location.pathname === '/zh-CN/auth'
    || location.pathname?.startsWith('/zh-CN/auth/')
    ? '/zh-CN/matches'
    : '/matches'
  const returnTo = returnTargetFromSearch(location.search)
  if (returnTo && isSafeRelativeNavigationTarget(returnTo) && !isAuthLoop(returnTo))
    return returnTo
  return fallback ?? localeFallback
}
